'use client';

import type {FC} from 'react';

import {type ImageWeb} from '@/modules/foundation/components/image/types';
import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import {Gallery} from '@/modules/page/components/content-blocks/gallery';

import type {GalleryFragmentType} from './query';

interface Props {
	data?: GalleryFragmentType;
}

export const GalleryContainer: FC<Props> = ({data}) => {
	const {contentBlockOptions, images, aspectRatio} = data ?? {};

	if (!images || images.length === 0) {
		return null;
	}

	const carouselImages: KeyedArray<ImageWeb> = [];

	for (const sanityImage of images) {
		const img = imageWebFromImageWebSchema(sanityImage);
		if (!img) {
			continue;
		}

		carouselImages.push({
			_key: sanityImage._key,
			...img,
		});
	}

	if (!carouselImages || carouselImages.length === 0) {
		return null;
	}

	return <Gallery {...contentBlockOptions} images={carouselImages} aspectRatio={aspectRatio} />;
};
